"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_js_1 = __importDefault(require("currency.js"));
exports.default = (function (price) {
    if (!price && price !== 0) {
        return '';
    }
    // if price is an integer, it's assumed that it's in cents
    if (Number.isInteger(price)) {
        price = price / 100;
    }
    if (typeof price === 'string') {
        price = parseFloat(price);
    }
    return "$".concat((0, currency_js_1.default)(price));
});
